import { render } from "./Printer.vue?vue&type=template&id=7ceaecf3"
import script from "./Printer.vue?vue&type=script&lang=js"
export * from "./Printer.vue?vue&type=script&lang=js"
script.render = render

export default script